export async function sendAptosFormattedEmail(
  toEmail: string,
  subject: string,
  bodyText: string,
  ccEmail: string = '',
  onSuccess?: (msg: string) => void
) {
  // Convert plaintext linebreaks to HTML
  let htmlFragment = bodyText.replace(/\n/g, '<br/>')

  // Zero out margins for correct rendering
  htmlFragment = htmlFragment.replace(/<p>/gi, '<p style="margin:0;padding:0;">')
  htmlFragment = htmlFragment.replace(/<p\s+class=/gi, '<p style="margin:0;padding:0;" class=')
  htmlFragment = htmlFragment.replace(/<ul>/gi, '<ul style="margin:4px 0;padding-left:28px;">')
  htmlFragment = htmlFragment.replace(/<ol>/gi, '<ol style="margin:4px 0;padding-left:28px;">')
  htmlFragment = htmlFragment.replace(/<li>/gi, '<li style="margin:0;padding:0;">')

  // The requested Aptos size 12 corporate standard wrapper
  const htmlBody = `<div style="font-family:'Aptos',Calibri,Arial,sans-serif;font-size:12pt;color:#333333;line-height:1.5;">${htmlFragment}</div>`

  const w = window as any
  if (w.electronAPI && w.electronAPI.createOutlookEmail) {
    try {
      const res = await w.electronAPI.createOutlookEmail({
        to: toEmail,
        cc: ccEmail,
        subject: subject,
        body: htmlBody,
        isHtml: true
      })
      if (res.error) throw new Error(res.error)
      return
    } catch (e) {
      console.warn('Fallback to mailto', e)
      await fallbackMailto()
    }
  } else {
    await fallbackMailto()
  }

  async function fallbackMailto() {
    try {
      const clipboardItem = new ClipboardItem({
        'text/html': new Blob([htmlBody], { type: 'text/html' }),
        'text/plain': new Blob([bodyText], { type: 'text/plain' }),
      })
      await navigator.clipboard.write([clipboardItem])
    } catch {
      try { await navigator.clipboard.writeText(bodyText) } catch {}
    }

    const subjectEncoded = encodeURIComponent(subject)
    const bodyEncoded = encodeURIComponent(bodyText)
    const ccPart = ccEmail ? `cc=${encodeURIComponent(ccEmail)}&` : ''
    const mailtoUrl = `mailto:${toEmail}?${ccPart}subject=${subjectEncoded}&body=${bodyEncoded}`
    
    // Non usare _self per i link generati dinamicamente, potrebbe crasciare alcune SPAs, target vuoto o blank
    window.location.href = mailtoUrl

    if (onSuccess) {
      onSuccess('📋 Corpo email formattato in Aptos 12 copiato! Premi Ctrl+V in Outlook.')
    }
  }
}
